import React, { useEffect, useRef, useState } from "react";
import "./Contact.scss";
import ContactForm from "../ContactForm/ContactForm";
import Cover from "../Cover/Cover";
import MainButton from "../MainButton/MainButton";
import mapStyles from "../AmenitiesGMap/mapstyle.json";
import LinkedInIcon from "../LinkedInIcon/LinkedInIcon";
import InstagramIcon from "../InstagramIcon/InstagramIcon";
import FacebookIcon from "../FacbookIcon/FacebookIcon";
import TwitterIcon from "../TwitterIcon/TwitterIcon";
import { useSelector } from "react-redux";
import MobileFooter from "../MobileFooter/MobileFooter";
import RegisterForm from "../RegisterForm/RegisterForm";

const Contact = () => {
    //form stuff that was transfered over
    const form = useSelector((state) => state.content.options.form);
    const submitted =
        useSelector((state) => state.content.options.form_submitted) || false;
    const submitting =
        useSelector((state) => state.content.options.form_submitting) || false;
    const consent_error =
        useSelector((state) => state.content.options.consent_error) || false;

    const content = useSelector((state) => state.content.pages.contact);
    var mapContainer = useRef();
    var [gMap, setgMap] = useState(null);
    var mapData = useSelector((state) => state.content.pages.area);

    useEffect(() => {
        //console.log("contact loaded");
        //console.log(document.querySelector("#root"));
        //document.querySelector("#root").scrollTo(0, 0);
        window.scrollTo(0, 0);
    }, []);

    function startMap(mainPin) {
        var map = {};
        map.markers = [];
        map.map = null;

        map.createMap = function (mainPin) {
            map.map = new window.google.maps.Map(mapContainer.current, {
                zoom: 15,
                center: {
                    lat: parseFloat(mainPin.latitude),
                    lng: parseFloat(mainPin.longitude),
                },
                styles: mapStyles,
            });
        };

        map.addMarkers = function (mainPin) {
            this.removeMarkers();
            this.markers = [];

            this.markers.push(
                this.createMarker({
                    lat: parseFloat(mainPin.latitude),
                    lng: parseFloat(mainPin.longitude),
                    name: "",
                    icon: {
                        url: mainPin.icon,
                        //scaledSize: new window.google.maps.Size(182, 47)
                        scaledSize: new window.google.maps.Size(91, 23.5),
                    },
                })
            );
        };

        map.removeMarkers = function () {
            for (var i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }
        };

        map.createMarker = function (markerData) {
            console.log(markerData);

            var marker = new window.google.maps.Marker({
                position: {
                    lat: markerData.lat,
                    lng: markerData.lng,
                },
                map: this.map,
                icon: markerData.icon ? markerData.icon : "",
            });

            return marker;
        };

        map.createMap(mainPin);
        map.addMarkers(mainPin);
        return map;
    }

    //map effects
    useEffect(() => {
        if (typeof content !== "undefined") {
            if (gMap == null) {
                setgMap(startMap(mapData.map[0].main_pin));
            }
        }
    });

    if (typeof content !== "undefined") {
        return (
            <div className="contact">
                <Cover />
                <div class="left-side-container">
                    <div className="heading-container">
                        <h2>
                            {content.form_contact_info.heading}
                            <img
                                className="h2-heading-decoration"
                                src={content.form_contact_info.heading_image}
                            />
                        </h2>
                    </div>
                    <div className="g-map-wrapper">
                        <div className="g-map-container" ref={mapContainer} />
                    </div>
                    <div className="contact-info-container">
                        <div className="contact-info">
                            <div className="contact-info-grid">
                                <a
                                    className="contact-link"
                                    href={
                                        content.form_contact_info.phone_number
                                            .tel_number
                                    }
                                >
                                    <div className="icon-container">
                                        {content.form_contact_info.phone_number
                                            .icon && (
                                            <img
                                                className="icon"
                                                src={
                                                    content.form_contact_info
                                                        .phone_number.icon
                                                }
                                            />
                                        )}
                                    </div>
                                    {
                                        content.form_contact_info.phone_number
                                            .label
                                    }
                                </a>
                                <span className="contact-label">
                                    <div className="icon-container">
                                        {content.form_contact_info.address
                                            .link_icon && (
                                            <img
                                                className="icon"
                                                src={
                                                    content.form_contact_info
                                                        .address.link_icon
                                                }
                                            />
                                        )}
                                    </div>
                                    <div
                                        class="content"
                                        dangerouslySetInnerHTML={{
                                            __html: content.form_contact_info
                                                .address.text_address,
                                        }}
                                    />
                                </span>
                                <a
                                    href={
                                        content.form_contact_info.email
                                            .mailto_address
                                    }
                                    className="contact-link"
                                >
                                    <div className="icon-container">
                                        {content.form_contact_info.email
                                            .icon && (
                                            <img
                                                className="icon"
                                                src={
                                                    content.form_contact_info
                                                        .email.icon
                                                }
                                            />
                                        )}
                                    </div>
                                    {content.form_contact_info.email.label}
                                </a>
                                <a
                                    className="contact-link contact-address"
                                    href={
                                        content.form_contact_info.address
                                            .address_link
                                    }
                                    target="_blank"
                                >
                                    <div className="icon-container" />
                                    {
                                        content.form_contact_info.address
                                            .link_label
                                    }
                                </a>
                                {content.form_contact_info.meeting_button
                                    .text &&
                                    content.form_contact_info.meeting_button
                                        .link && (
                                        <MainButton
                                            text={
                                                content.form_contact_info
                                                    .meeting_button.text
                                            }
                                            link={
                                                content.form_contact_info
                                                    .meeting_button.link
                                            }
                                            blank={
                                                content.form_contact_info
                                                    .meeting_button.blank
                                            }
                                            external
                                        />
                                    )}
                                {content.form_contact_info.appointment_button
                                    .text &&
                                    content.form_contact_info.appointment_button
                                        .link && (
                                        <MainButton
                                            text={
                                                content.form_contact_info
                                                    .appointment_button.text
                                            }
                                            link={
                                                content.form_contact_info
                                                    .appointment_button.link
                                            }
                                            blank={
                                                content.form_contact_info
                                                    .appointment_button.blank
                                            }
                                            external
                                        />
                                    )}
                            </div>
                            <div className="contact-office-hours">
                                <h2 class="hours-heading">
                                    Model Home and Office Hours
                                </h2>
                                <div class="hours">
                                    <div className="hour-item">
                                        <span className="days">
                                            Monday to Wednesday:
                                        </span>
                                        <span className="time">12PM - 6PM</span>
                                    </div>
                                    <div className="hour-item">
                                        <span className="days">
                                            Thursday & Friday:
                                        </span>
                                        <span className="time">Closed</span>
                                    </div>
                                    <div className="hour-item">
                                        <span className="days">
                                            Saturday & Sunday:
                                        </span>
                                        <span className="time">12PM - 5PM</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-side-container">
                    <div className="contact-info-container">
                        <div className="contact-info">
                            <div className="heading-container">
                                <h2>
                                    {content.form_contact_info.heading}
                                    <img
                                        className="h2-heading-decoration"
                                        src={
                                            content.form_contact_info
                                                .heading_image
                                        }
                                    />
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div class="form-wrapper">
                        <div class="form-content">
                            <h3 class="form-content-heading">
                                {content.form_heading}
                            </h3>
                            <p class="form-content-p">{content.form_content}</p>
                        </div>
                        <div
                            class={`form-container${submitted ? " submitted" : ""}`}
                        >
                            {typeof form !== "undefined" && (
                                <RegisterForm
                                    form={form}
                                    submitted={submitted}
                                    submitting={submitting}
                                    consent_error={consent_error}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return <div></div>;
    }
};

export default Contact;
